import type { DtoolsDisplaySettings, DtoolsPortalPaymentTerm } from "./dtoolsDisplaySettings";
import {
  DTOOLS_DEFAULT_PAYMENT_TERMS,
  readDtoolsPaymentTermsFromJson,
  resolveDtoolsPaymentTerms,
} from "./dtoolsDisplaySettings";
import type { ManualApprovedPaymentTerm } from "./manualApprovedProposalWrapper";

export type CustomerFacingPaymentTerm = ManualApprovedPaymentTerm;

/**
 * Customer-facing payment terms with company-default fallback.
 *
 * Priority:
 * 1. Proposal-specific terms when showPaymentTerms is explicitly enabled
 * 2. Stored header terms when showPaymentTerms is unset (retail / legacy)
 * 3. Published/default Clarity payment terms (50/40/10)
 */
export function resolveCustomerFacingPaymentTerms(input: {
  paymentTermsJson?: unknown;
  paymentTerms?: CustomerFacingPaymentTerm[];
  displaySettings?: Pick<DtoolsDisplaySettings, "showPaymentTerms">;
}): CustomerFacingPaymentTerm[] {
  const stored =
    input.paymentTerms?.length && input.paymentTerms.length > 0
      ? input.paymentTerms
      : readDtoolsPaymentTermsFromJson(input.paymentTermsJson);

  if (input.displaySettings?.showPaymentTerms === true) {
    return stored.length > 0 ? stored : [...DTOOLS_DEFAULT_PAYMENT_TERMS];
  }
  if (input.displaySettings?.showPaymentTerms === false) {
    return [...DTOOLS_DEFAULT_PAYMENT_TERMS];
  }
  return resolveDtoolsPaymentTerms(input.paymentTermsJson);
}

/** Last-resort display fallback — never show "unavailable" when defaults exist. */
export function withPaymentTermsDisplayFallback(
  terms: CustomerFacingPaymentTerm[] | DtoolsPortalPaymentTerm[],
): CustomerFacingPaymentTerm[] {
  if (terms.length > 0) return terms;
  return DTOOLS_DEFAULT_PAYMENT_TERMS.length > 0 ? [...DTOOLS_DEFAULT_PAYMENT_TERMS] : [];
}
